const { find_entry_item,set_feedback_message } = require('./util.js'); 
const {ValidationError} = require('./exception.js');


//FIXME:ちゃんと仕様をコメントにして残す
module.exports = (current_slide_name,application_swiper,strict_name_match=true,checker,item_name,item_name_readable) => {

    let ary_checker;
    let DOM_check_target;

    DOM_check_target = find_entry_item(current_slide_name,strict_name_match,item_name);
    
    if(checker == false) throw Error(`invalid checker(slide:${current_slide_name} item:${item_name})`);

    //if(!(typeof checker === "function")) throw Error(`invalid checker(slide:${current_slide_name} item:${item_name})`);

    let check_successful=true;
    let last_error;


    if(typeof checker === "function"){
        ary_checker = Array(checker);
    } else if(Array.isArray(checker)){
        ary_checker = checker;
    }

    for(var checker of ary_checker){
        try {
            checker.call(null,DOM_check_target.value,{
                DOM_target:DOM_check_target,
                item_name:item_name,
                item_name_readable:item_name_readable,
            });
        } catch(err){
            let feedback_text;
            if(err instanceof ValidationError){
                //FIXME:例外オブジェクトからフィードバックメッセージを受け取る
                if(err.readableMessage){
                    feedback_text=err.readableMessage;
                } else {
                    feedback_text="入力がただしくありません。";
                }
                
                set_feedback_message(DOM_check_target,feedback_text);
                check_successful = false;     
                last_error = err;
            }
        }
    }

    if(check_successful){
        DOM_check_target.classList.remove('is-invalid');
    } else {
        DOM_check_target.classList.add('is-invalid');
    }
    if(last_error){
        throw last_error;
    }
}
